export enum SolutionsSummarySideBarEnums {
  BlueThemedContactUsPageRedirect = 'blue_themed_contact_us_page',
  DarkThemedContactUsPageRedirect = 'dark_themed_contact_us_page',
  Default = 'default_contact_us_page',
}
